import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgChangeArrows = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.443 10.431a.598.598 0 0 1-.6.6h-5a.6.6 0 1 1 0-1.2h3.485l-2.763-2.596-.013-.013A6.9 6.9 0 0 0 5.167 9.798a.6.6 0 0 1-1.131-.4 8.1 8.1 0 0 1 13.358-3.03l2.849 2.676V5.431a.6.6 0 1 1 1.2 0v5ZM2.234 13.667a.598.598 0 0 1 .6-.6h5a.6.6 0 1 1 0 1.2H4.35l2.763 2.596.013.013A6.9 6.9 0 0 0 18.51 14.3a.6.6 0 1 1 1.132.4 8.1 8.1 0 0 1-13.359 3.031l-2.849-2.677v3.613a.6.6 0 0 1-1.2 0v-5Z",
    fill: "#fff"
  })
}));
export default SvgChangeArrows;